export function HomeBrandLogo() {
  return (
    <div className="home-brand">
      <img src="/brand/bpm-a-montaner.svg" alt="BPM · Montaner" width={1000} height={320} />
    </div>
  );
}
